import { Component, EventEmitter, Input, Output } from '@angular/core';

/** Type de document cible pour la conversion depuis un ticket de caisse. */
export type ConvertDocumentTarget = 'facture' | 'facture_consolidation' | 'facture_client';

/** Référence minimale au ticket (évite une dépendance circulaire avec poscontent). */
export interface TicketConvertRef {
    id: string;
    numero: string;
}

@Component({
    selector: 'app-convert-tick-caiss',
    templateUrl: './convert-tick-caiss.component.html',
    styleUrls: ['./convert-tick-caiss.component.scss']
})
export class ConvertTickCaissComponent {
    @Input() ticket: TicketConvertRef | null = null;

    @Output() closed = new EventEmitter<void>();
    @Output() convert = new EventEmitter<ConvertDocumentTarget>();

    /** Libellés alignés sur convert-modal (Devis) — valeur par défaut comme la maquette POS. */
    selectedDocumentType: string | null = 'Facture de consolidation';

    private readonly imageBase = 'assets/images/logo/';

    selectDocumentType(value: string): void {
        this.selectedDocumentType = value;
        this.onDocumentTypeChange();
    }

    onDocumentTypeChange(): void {
        /* hook si besoin (tracking, etc.) */
    }

    getImageSrc(): string {
        if (!this.selectedDocumentType) {
            return this.imageBase + 'Card.png';
        }
        switch (this.selectedDocumentType) {
            case 'Facture':
                return this.imageBase + 'CardTicketCaisse.png';
            case 'Facture de consolidation':
                return this.imageBase + 'CardTicketCaisse.png';
            case 'Facture client':
                return this.imageBase + 'CardTicketCaisse.png';
            default:
                return this.imageBase + 'CardTicketCaisse.png';
        }
    }

    onBackdropClick(event: MouseEvent): void {
        if (event.target === event.currentTarget) {
            this.onCancel();
        }
    }

    onCancel(): void {
        this.closed.emit();
    }

    onConvertClick(): void {
        const target = this.mapLabelToTarget(this.selectedDocumentType);
        if (target) {
            this.convert.emit(target);
        }
    }

    private mapLabelToTarget(label: string | null): ConvertDocumentTarget | null {
        switch (label) {
            case 'Facture':
                return 'facture';
            case 'Facture de consolidation':
                return 'facture_consolidation';
            case 'Facture client':
                return 'facture_client';
            default:
                return null;
        }
    }
}
